export const EMPTY_ARRAY = []
export const EMPTY_OBJECT = {}
export const DEFAULT_FUNCTION = () => {}

export const RESPONSIVE_BREAKPOINTS = {
  xSmall: 425,
  small: 768,
  large: 1040
}

export const SIZE_DESKTOP = 'desktop'
export const SIZE_TABLET = 'tablet'
export const SIZE_PHONE = 'phone'

export const FORMS = {
  SINGLE_QUOTE: 'singleQuote',
  SINGLE_QUOTE_DESKTOP_SIDEBAR: 'singleQuoteDesktop',
  SINGLE_QUOTE_MOBILE: 'singleQuoteMobile',
  QUOTE_AFTER_DOWNLOAD: 'quoteAfterDownload',
  WIDGET_QUOTE_AFTER_DOWNLOAD: 'widgetQuoteAfterDownload',
  BATCH_QUOTE: 'batchQuote',
  CLAIM_PAGE: 'claimPage'
}

export const KEYS = {
  BACKSPACE: 8,
  TAB: 9,
  ENTER: 13,
  SHIFT: 16,
  CTRL: 17,
  ALT: 18,
  ESC: 27,
  SPACE: 32,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  DELETE: 46
}

export const TERMS_AND_CONDITIONS_URL = 'https://daaily.com/terms-conditions.html'
export const PRIVACY_POLICY_URL = 'https://daaily.com/privacy-policy.html'
export const RECAPTCHA_SITEKEY = '6LdAAXgUAAAAAF4SGaUBUb360KEclFkQDCm4Lyj2'

// Possible Form Fields
export const NAME = 'name'
export const EMAIL = 'email'
export const COUNTRY = 'country'
export const LOCATION = 'location'
export const BRANCH = 'branch'
export const USE = 'use'
export const MOTIVE = 'motive'
export const DETAILS = 'details'
export const REQUEST_SAMPLE = 'request_a_sample'
export const KENNETH_ID = 'kenneth_id'
export const REFERRER = 'referrer'
export const AD_SOURCE = 'ad_source'
export const AD_MEDIUM = 'ad_medium'
export const AD_NAME = 'ad_name'
export const WORLD_CITY_ID = 'world_city_id'
export const GEO_IP = 'geoip'
export const RECAPTCHA_RESPONSE = 'g-recaptcha-response'
export const PRODUCT = 'product'
export const CATEGORY = 'category'
export const TYPE_OF_REQUEST = 'typeOfRequest'
export const COMPANY = 'company'
export const PHONE = 'phone'
export const DEVICE = 'device'
export const ACCOUNT_ID = 'account_id'
export const COMPANY_WEBSITE = 'company_website'

export const FORM_WITH_PHONE = ['cl', 'mx', 'co', 'pe', 'br', 'us']

export const SINGLE_FORM_TEMPLATE = [ NAME, EMAIL, COUNTRY, LOCATION, BRANCH, TYPE_OF_REQUEST, PHONE, DETAILS ]
export const BATCH_FORM_TEMPLATE = [ USE, MOTIVE, DETAILS ]

// Template & selects for old forms (contact from company page)
export const irFormTemplate = [ BRANCH, COUNTRY, LOCATION, COMPANY, EMAIL, NAME, PHONE, DETAILS ]
export const selects = [ COUNTRY, LOCATION ]

export const FIELDS_IN_COOKIE = [ NAME, EMAIL, BRANCH, COUNTRY, LOCATION, PHONE, COMPANY_WEBSITE ]

export const COMPANY_PAGE = 'companies-show';
export const ACCOUNT_FILES = 'companies-account_files';
export const BIM_FILES_PAGE = 'companies-bim_files';
export const PRODUCT_PAGE = 'products-show';
export const GALLERY_PAGE = 'gallery-show';

export const PAGES_WITH_DOWNLOAD_IR = [ COMPANY_PAGE, ACCOUNT_FILES, BIM_FILES_PAGE, PRODUCT_PAGE, GALLERY_PAGE ];
export const ALLOW_PRODUCT_DOWNLOAD_IR = [ BIM_FILES_PAGE, PRODUCT_PAGE, GALLERY_PAGE ];
